export const getListWithoutId = (firstList: string[], secondList: string[]) => {
  let result: string[] = secondList;

  firstList.forEach((id) => {
    result = secondList.includes(id)
      ? secondList.filter((i) => i !== id)
      : secondList;
  });

  return result;
};
